import React from "react";
import EngineeringScope from "../components/forms/EngineeringScopeForm";

const ProjectInformation: React.FC = () => {
  return (
   <>
   <EngineeringScope />
   </>
  );
};

export default ProjectInformation;
